import { useState } from 'react'
import CheckBoxs from '../../../components/CheckBoxs'
import { useHistory } from 'react-router'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Alert, { ActionsOptType } from '../../../components/Alert'
import { Typography, Box } from '@material-ui/core'
import { updateService } from '../../../services/services'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import { sendShareDocumentEmail } from '../../../services/emails'
import DialogContentText from '@material-ui/core/DialogContentText'

// Define IdialogShare interface
interface IDialogShare {
  open: boolean,
  setOpen: (newState: boolean) => void,
  people: any[],
  idService: string | undefined,
  user_id: string | undefined
}
  
/**
 * Custom `ShareDocumentDialog` component declaration.
 * This component is used to 
 * @param {Boolean} open
 * @param {Function} setOpen
 * @param {Array} people
 * @param {String} idService
 * @param {String} user_id
 * @return ShareDocumentDialog
*/  
const ShareDocumentDialog = ({
  open,
  setOpen,
  people,
  idService,
  user_id
}: IDialogShare): JSX.Element => {
  const history = useHistory()
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })
  const [dataShareTo, setDataShareTo] = useState<any[]>([]);

  /**
   * This method is used to close dialog
   * @Return {void}
  */
  const handleClose = () => {
    setOpen(false)
  }

  /**
   * This method is used to update the database, the service table on the dataShateTo column
   * @Return {void}
  */
  const updateCurrentService = async () => {
    await updateService({
      id: idService,
      share_to: dataShareTo
    })
  }

  /**
   * This method is used to capture emails and permissions, send emails and redirect the app
   * @Return {void}
  */
  const sendEmail = () => {
    const arrayPeople: any[] = []
    dataShareTo.forEach(element => {
      arrayPeople.push(element[0])
    })
    updateCurrentService()
    sendShareDocumentEmail(user_id, arrayPeople)
    handleClose()
    history.push('/documents')
  }

  return (
    <Dialog
      open={open}
      aria-labelledby="form-dialog-title"
    >
      <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />
      <DialogContent>
        <DialogContentText style={{whiteSpace: 'pre-line'}}>
          {`\n ¡Comparte tu documento!
            \n Esta opción te permite compartir el documento con las personas involucradas.
            \n Para hacerlo, solo debes escribir el correo de la persona y nosotros nos encargaremos de hacer posible que pueda ingresar a nuestra plataforma y pueda firmar el documento.
          `}
        </DialogContentText>
        <Box style={{display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="subtitle1" align='center' style={{ marginLeft:'1.8vh', marginTop:'0.3vh', marginBottom:'1vh', fontWeight: 'bold' }}>
            Correo electrónico
          </Typography>
          <Box style={{display: 'flex', justifyContent: 'space-between'}}>
          <Typography variant="subtitle1" align='center' style={{ marginRight:'1vh', fontWeight: 'bold' }}>
              {`Solo firmar  -  `}
            </Typography>
            <Typography variant="subtitle1" align='center' style={{ marginRight:'2.3vh', fontWeight: 'bold' }}>
              {`Firmar y editar`}
            </Typography>
          </Box>
        </Box>
        {people.map((item, index) => (
          <CheckBoxs 
            item={item}
            key={index}
            dataShareTo={dataShareTo}
            setDataShareTo={setDataShareTo}
          />
        ))}

      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancelar
        </Button>
        <Button onClick={sendEmail} color="primary">
          Compartir Documento
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ShareDocumentDialog